// extracted by mini-css-extract-plugin
export default {"container":"OrderDetails_container__qXxvD"};